import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { UserDetailState } from './useUserDetail';
import { clientPathLabel, indexClients } from '../../../utils/clientTree';

/** The Groups tab (ANEP staff only): the client groups, and for a SuperAdmin the way to add one. */
export const UserGroupsTab: React.FC<{ state: UserDetailState }> = ({ state }) => {
  const { t } = useI18n();
  const { groups, clientNames, isSuperAdmin, isLoadingGroups, availableClientsToAdd, allClients } = state;

  return (
    <div className="tab-content ud-tab">
      <section className="cu-section">
        <header className="cu-section-head">
          <h3>{t('users.currentClientGroups')}</h3>
          <p>{t('users.detail.groupsHint')}</p>
        </header>
        {groups.length > 0 ? (
          <ul className="ud-list">
            {groups.map((group) => {
              const displayName = clientNames.get(group.name) || group.name;
              const isClientGroup = group.path.startsWith('/Clients/');
              return (
                <li key={group.id} className="ud-row">
                  <div className="ud-row-text">
                    <strong>{displayName}</strong>
                    <span className="mono ud-row-sub">{group.path}</span>
                  </div>
                  {isSuperAdmin && isClientGroup && (
                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => state.removeClientGroup(group.id, displayName)} disabled={isLoadingGroups}>
                      {t('users.remove')}
                    </button>
                  )}
                </li>
              );
            })}
          </ul>
        ) : (
          <p className="ud-empty">{t('users.notAnyGroup')}</p>
        )}
      </section>

      {isSuperAdmin && (
        <section className="cu-section">
          <header className="cu-section-head">
            <h3>{t('users.addClientGroup')}</h3>
            <p>{t('users.detail.addGroupHint')}</p>
          </header>
          <div className="cu-input-row ud-add-row">
            <select className="cu-input" value={state.selectedClientToAdd} data-testid="field-user-add-group-client"
                    onChange={(e) => state.setSelectedClientToAdd(e.target.value)} disabled={isLoadingGroups} aria-label={t('clients.client')}>
              <option value="">{t('users.selectClient')}</option>
              {availableClientsToAdd.map((client) => <option key={client.id} value={client.id}>{clientPathLabel(client, indexClients(allClients))}</option>)}
            </select>
            <button type="button" className="btn btn-primary btn-sm" data-testid="btn-user-add-group" onClick={state.addClientGroup} disabled={isLoadingGroups || !state.selectedClientToAdd}>
              {isLoadingGroups ? t('users.adding') : t('users.addToGroup')}
            </button>
          </div>
          {availableClientsToAdd.length === 0 && allClients.length > 0 && <p className="cu-hint">{t('users.alreadyInAllGroups')}</p>}
        </section>
      )}
    </div>
  );
};
